import api from '@/api/api'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const SET_EDIT = 'SET_EDIT'
export const LOAD_PLANOS_PAGAMENTO = 'LOAD_PLANOS_PAGAMENTO'
export const INATIVAR_PLANO_PAGAMENTO = 'INATIVAR_PLANO_PAGAMENTO'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    planos: null,
    loading: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [LOAD_PLANOS_PAGAMENTO] ({ commit }) {
    commit(SET_STATE, { loading: true })
    await api.listEntidade('plano-pagamento').then(
      planos => {
        commit(SET_STATE, { planos, loading: false })
      },
    )
  },
  async [BOOTSTRAP] ({ dispatch }) {
    await dispatch(LOAD_PLANOS_PAGAMENTO)
  },
  async [INATIVAR_PLANO_PAGAMENTO] ({ dispatch }, plano) {
    Swal.fire({
      title: 'Tem certeza que deseja excluir o Plano de Pagamento?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        return api.inativarEntidade('plano-pagamento', plano.id).then(
          result => result,
          ({
            error = null,
            message = 'Não foi possivel excluir o Plano de Pagamento!',
          }) => {
            Swal.fire({
              icon: 'error',
              title: error === null ? 'Ocorreu algum erro!' : 'Erro!',
              text: message,
            })
          },
        )
      },
    }).then(
      result => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'O Plano de Pagamento foi excluído com sucesso!',
            icon: 'success',
            showConfirmButton: false,
            timer: 2500,
          })
          dispatch(BOOTSTRAP)
        }
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
